import { Route, Routes, ScrollRestoration } from "react-router-dom";
import Setup from "./pin/Setup";
import Change from "./pin/Change";

const Pin = () => {
  return (
    <>
      <ScrollRestoration />
      <Routes>
        <Route path="/" element={<Setup />} />
        <Route path="setup" element={<Setup />} />
        <Route path="change" element={<Change />} />
      </Routes>
    </>
  );
};

export default Pin;
